// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"45":"ef89cf09a055a226","195":"ef89cf09a055a226","888":"b6f2b712db5760e7","986":"ef89cf09a055a226"}[chunkId] + ".css";
};